export const SearchIcon = () => (
  <span className="inline-flex h-5 w-5 items-center justify-center">
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M17.593 17.5L13.2622 13.1692M13.2622 13.1692C14.4344 11.9971 15.0929 10.4073 15.0929 8.74962C15.0929 7.09196 14.4344 5.50219 13.2622 4.33004C12.0901 3.15789 10.5003 2.49939 8.84263 2.49939C7.18496 2.49939 5.59519 3.15789 4.42304 4.33004C3.2509 5.50219 2.59239 7.09196 2.59239 8.74962C2.59239 10.4073 3.2509 11.9971 4.42304 13.1692C5.59519 14.3414 7.18496 14.9999 8.84263 14.9999C10.5003 14.9999 12.0901 14.3414 13.2622 13.1692Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  </span>
);
